import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import {gridMargin} from "./general";
import {withStyles} from "@material-ui/core";


const styles = () => {
	return {
		optGroup: {
			//color: '#999',
			cursor: 'default',
			display: 'block',
			fontSize: '75%',
			fontWeight: 500,
			marginBottom:  0,
			textTransform: 'uppercase',
			boxSizing: 'border-box',
			minHeight : 20,
		},
		option: {},
		optionInGroup: {
			marginLeft: 15,
		}
	};
};

class FormSelect extends PureComponent {
	render () {
		const {
			label, value, path, onChange, required,
			error, options, helpText, disabled, gridProps,
			classes,
		} = this.props;

		const _onChange = event => {
			onChange(event.target.value, path);
		};

		const optionClass = (_.some(options, 'isGroup'))
			? classes.optionInGroup
			: classes.option;

		//let value, onChange, error;
		const hasError = !!error;
		const content = (
			<FormControl required={required} fullWidth={true} error={hasError} disabled={disabled}>
				<InputLabel htmlFor={path}>{label}</InputLabel>
				<Select
					required={required}
					value={value}
					onChange={_onChange}
					input={<Input name={path} id={path}/>}
				>
					{options && options.map(option => {

						/** @namespace option.isGroup **/
						if (option.isGroup) {
							return (<MenuItem disabled key={option.display} className={classes.optGroup}>
								{option.display}
							</MenuItem>);
						} else {
							return (<MenuItem key={option.value} value={option.value} className={optionClass}>
								{option.display}
							</MenuItem>);
						}
					})}
				</Select>
				{hasError && <FormHelperText>{error}</FormHelperText>}
				{(helpText && !hasError) && <FormHelperText>{helpText}</FormHelperText>}
			</FormControl>
		);

		if (gridProps) {
			_.defaults(gridProps, { xs : 12 });
			return (<Grid item {...gridProps} style={gridMargin}>{content}</Grid>);
		} else {
			return content;
		}
	}
}

FormSelect.propTypes = {
	label : PropTypes.string.isRequired,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	options : PropTypes.array.isRequired,

	helpText : PropTypes.string,
	disabled : PropTypes.bool,
	required : PropTypes.bool,

	gridProps : PropTypes.object,
};

FormSelect.defaultProps = {
	required : false,
};

export default _.flow([
	withStyles(styles),
])(FormSelect);

